import { map } from 'lodash'

export default {
  getProfessionalCompany (address) {
    if (!address) {
      return
    }
    if (address !== 'undefined') {
      this.$http.get('/v1/search/staffs/staff-by-address/' + address.id)
          .then((data) => {
            this.optionsCompanyProfessional = data.data
          })
          .catch(({data, meta}) => {
            this.errors = data
          })

      this.optionsCompanyProfessional = []
    }
  },
  setSpecialitiesFromProfessional (professional) {
    // selecionando especialidades e setando ao profisssional,
    this.$http.get('/v1/search/staffs/speciality/' + professional)
        .then((data) => {
          this.optionsCompanyProfessionalSpecialities = data.data
        })
        .catch(({data, meta}) => {
          this.errors = data
        })

    this.agenda.specialities = []
  },
  prepareShow (agenda) {
    // inativa para edição
    if (agenda.service_network === 'private') {
      this.convenantHidden = false
      this.agendaIsPrivate = true
    }
    return agenda
  },
  prepareSave (agenda) {
    agenda.specialities = map(agenda.specialities, speciality => {
      return {
        speciality_id: speciality.id
      }
    })
    agenda.covenants = map(agenda.covenants, covenant => {
      return {
        covenant_id: covenant.id
      }
    })
    if (agenda.covenants.length < 1) {
      delete agenda.covenants
    }

    return agenda
  },
  afterSave (price) {
    this.saved = true
  },
  afterCreated (data) {
    this.nextStepButtonsRules = [
      {
        icon: '',
        text: 'Cadastrar Regra',
        route: {
          name: 'professional.agenda.rules.create',
          query: {agenda_id: data.id}
        },
        action: null
      }
    ]

    this.wasRaised = true
    this.show = true
  },
  afterUpdated (data) {
    this.nextStepButtonsRules = [
      {
        icon: '',
        text: 'Cadastrar Regra',
        route: {
          name: 'professional.agenda.rules.create',
          query: {agenda_id: data.id}
        },
        action: null
      }
    ]
    this.beenUpdated = true
    this.show = true
  },
  idPrivate (isprivate) {
    if (isprivate === 'private') {
      this.convenantHidden = false
      this.agendaIsPrivate = true
    }
    if ((isprivate === 'all') || (isprivate === 'covenant')) {
      this.convenantHidden = true
      this.agendaIsPrivate = false
    }
  },
  doNotAgendaPrivate () {
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/form/resources/methods.js